import { createBrowserRouter, Navigate } from 'react-router-dom'
import AdminLayout from '@/layouts/AdminLayout'
import MobileLayout from '@/layouts/MobileLayout'
import DeviceRedirect from '@/components/DeviceRedirect'

// Admin Pages
import AdminLogin from '@/pages/admin/Login'
import Dashboard from '@/pages/admin/Dashboard'
import Trend from '@/pages/admin/Trend'
import Plat from '@/pages/admin/Plat'
import User from '@/pages/admin/User'
import AdminAccount from '@/pages/admin/Account'
import Device from '@/pages/admin/Device'
import Error from '@/pages/admin/Error'
import Node from '@/pages/admin/Node'
import Cost from '@/pages/admin/Cost'
import Recharge from '@/pages/admin/Recharge'
import Withdrawal from '@/pages/admin/Withdrawal'
import Addresses from '@/pages/admin/Addresses'
import IpPool from '@/pages/admin/IpPool'
import IpCache from '@/pages/admin/IpCache'
import Task from '@/pages/admin/Task'
import TaskDetail from '@/pages/admin/TaskDetail'
import Flow from '@/pages/admin/Flow'
import Interface from '@/pages/admin/Interface'
import Dev from '@/pages/admin/Dev'
import ApiLogs from '@/pages/admin/ApiLogs'
import LoginLog from '@/pages/admin/LoginLog'
import Logs from '@/pages/admin/Logs'
import Order from '@/pages/admin/Order'
import TaskManage from '@/pages/admin/TaskManage'
import Strategy from '@/pages/admin/Strategy'
import JsDev from '@/pages/admin/JsDev'
import Apis from '@/pages/admin/Apis'
import AddInterface from '@/pages/admin/AddInterface'
import ApiTest from '@/pages/admin/ApiTest'
import Block from '@/pages/admin/Block'

// Mobile Pages
import MobileLogin from '@/pages/mobile/Login'
import TaskList from '@/pages/mobile/TaskList'
import MobileAccount from '@/pages/mobile/Account'
import AccountDetail from '@/pages/mobile/AccountDetail'
import Withdraw from '@/pages/mobile/Withdraw'
import MobileAddresses from '@/pages/mobile/Addresses'
import RechargeStatus from '@/pages/mobile/RechargeStatus'
import MobileTrend from '@/pages/mobile/Trend'

// Standalone Pages
import Live from '@/pages/Live'

export const router = createBrowserRouter([
  {
    path: '/',
    element: <DeviceRedirect />
  },
  {
    path: '/admin',
    element: <AdminLayout />,
    children: [
      { index: true, element: <Navigate to="/admin/dashboard" replace /> },
      { path: 'dashboard', element: <Dashboard /> },
      { path: 'trend', element: <Trend /> },
      { path: 'block', element: <Block /> },
      { path: 'plat', element: <Plat /> },
      { path: 'account', element: <AdminAccount /> },
      { path: 'task', element: <Task /> },
      { path: 'task/:id', element: <TaskDetail /> },
      { path: 'interface', element: <Interface /> },
      { path: 'dev', element: <Dev /> },
      { path: 'flow', element: <Flow /> },
      { path: 'apilogs', element: <ApiLogs /> },
      { path: 'loginlog', element: <LoginLog /> },
      { path: 'logs', element: <Logs /> },
      { path: 'user', element: <User /> },
      { path: 'device', element: <Device /> },
      { path: 'error', element: <Error /> },
      { path: 'node', element: <Node /> },
      { path: 'cost', element: <Cost /> },
      { path: 'recharge', element: <Recharge /> },
      { path: 'withdrawal', element: <Withdrawal /> },
      { path: 'addresses', element: <Addresses /> },
      { path: 'ippool', element: <IpPool /> },
      { path: 'ipcache', element: <IpCache /> },
      { path: 'order', element: <Order /> },
      { path: 'taskmanage', element: <TaskManage /> },
      { path: 'strategy', element: <Strategy /> },
      { path: 'jsdev', element: <JsDev /> },
      { path: 'apis', element: <Apis /> },
      { path: 'interface/add', element: <AddInterface /> },
      { path: 'interface/:id', element: <AddInterface /> },
      { path: 'apitest', element: <ApiTest /> },
    ]
  },
  {
    path: '/admin/login',
    element: <AdminLogin />
  },
  {
    path: '/mobile',
    element: <MobileLayout />,
    children: [
      { index: true, element: <Navigate to="/mobile/task" replace /> },
      { path: 'task', element: <TaskList /> },
      { path: 'account', element: <MobileAccount /> },
      { path: 'account/detail', element: <AccountDetail /> },
      { path: 'withdraw', element: <Withdraw /> },
      { path: 'addresses', element: <MobileAddresses /> },
      { path: 'rechargeStatus', element: <RechargeStatus /> },
      { path: 'trend', element: <MobileTrend /> },
    ]
  },
  {
    path: '/mobile/login',
    element: <MobileLogin />
  },
  {
    path: '/living',
    element: <Live />
  }
])
